import React from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetDisciplines } from "helpers/commonCodes";
import Label from "components/general/Label";
import { useState } from "react";
import { useNavigateTo } from "helpers/urlFriendly";
import { useGetNocs } from "helpers/commonCodes";
import Noc from "components/presentation/Noc";
import { useGetURL } from "helpers/urlFriendly";
import { Link } from "react-router-dom";
import PageHeader from 'components/common/PageHeader';
import { sortDataByFieldDesc } from "helpers/utils";

const NocList = () => {

    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'schedulebynoc')



    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    paramsURL["mirs_noc"] = "";


    //get nocs from memory 


    const data = useGetNocs(paramsURL)

    const note = data?.nocs?.filter(row => row.note === 'P') // Only shows the Nocs with note Participation ="P"
    const options = note?.map((item) => {
        sortDataByFieldDesc(note, 'longDescription')
        return (
            <ItemNoc item={item} urlparams={paramsURL} key={"Selector-Noc-" + item.code} />
        )
    })


    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_noc"] = key
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };

    return (

        <>
            <PageHeader title={<Label data="LabelNocs" />} />

            <div className='mirs-page-container'>

                <div onSelect={handleOnChange} title={<Label data={'LabelNocs'} />} id="nocList" className={"nocList-container"} >

                    <div className="noc-elements">
                        {options}
                    </div>

                </div>
            </div>
        </>

    );
};


const ItemNoc = ({ item, urlparams }) => {
    urlparams["mirs_noc"] = item.code;
    let url = useGetURL(urlparams, 'schedulebynoc')
    item.showLongDesc = true;
    return (
        <Link to={url} >
            <div className="itemNoc justify-content-left">
                <Noc {...item} />
            </div>
        </Link>
    )
};






export default NocList

